/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Popconfirm, Tooltip, Popover, Upload, Icon, Tag} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {formatMoney, openNotice} from '../../utils/index.js';
import {
    getOrderList,
    fetchChannelList,
    idDelete,
    refreshStatus
} from '../../service/order';
import moment from 'moment';
import {Store, Actions} from './store';
import {objectSerial, config, toImportExcel, downLoadTemplate} from 'Utils';
import {deleteGoods} from "../../service/returnGoods";
import {getGouXiaoUnitList} from "../../service/traceOrder";

class OrderList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelName = this.props.location.query.channelName || '';
        this.customerManagementId = this.props.location.query.customerManagementId ? parseInt(this.props.location.query.customerManagementId, 10) : '';
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.orgId = window.sessionStorage.getItem('cur_ouId');
        this.state = {
            opts: ['订单管理'],
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            key: 0,
            rows: [],
            total: 1,
            searchObj: {
                code: props.location.query.code || '',
                productCode: '',
                orderStatus: '',
                orderType: '',
                gatherRealityAddress: '',
                channelCode: this.channelData.split('|')[1] || '',
                getProCode: '',
                customerOrderCode: '',
                startCreatedDate: moment().add(-1, 'y').format('YYYY-MM-DD'),
                endCreatedDate: moment().format('YYYY-MM-DD'),
                buyCompanyId: '',
                remark: '',
                specialOfferCode: '',
                completeFactory: '',
                s: 10,
                p: 1,
            },
            channel_type: [], /* 渠道类型 */
            regionOptions: [], /* 所属区域 */
            loading: true,
            editVisible: 'block',
            salesAmount: 0,
        };
        this.exportChange = this.exportChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    goView(url) {
        hashHistory.push(url);
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgOrder/exportTgOrder?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    /*列表操作*/

    /*审核*/
    auditRecord(index) {
        console.log('audit' + index);
    }

    /*确认收货*/
    confirmRecord(index) {
        console.log('confirm' + index);
    }

    /*评价*/
    evaluationRecord(record) {
        hashHistory.push('order/evaluate/' + record.orderId + '/' + record.id);
    }

    /*编辑*/
    editRecord(record, index) {
        if (record.orderType == '1') {
            this.goView(`order/addConventional1/${9}&${record.id}`);
        }
        if (record.orderType == '2') {
            this.goView(`order/addProject1/${9}&${record.id}`);
        }
        if (record.orderType == '3') {
            this.goView(`order/addPartners1/${9}&${record.id}`);
        }
    }

    //刷新状态
    refreshRecord(record, index) {
        refreshStatus(record.id).then(result => {
            if (result.code == 200) {
                openNotice('success', '刷新成功', '');
                this.initData();
            } else {
                openNotice('error', result.message, '');
            }
        });
    }

    /* /!*删除*!/*/
    deleteRecord(index) {
        // console.log('delet' + index);
        idDelete(this.state.rows[index].id).then(result => {
            if (result.code == 200) {
                openNotice('success', '删除成功', '');
                this.initData();
            } else {
                openNotice('error', result.message, '');
            }
        })
    }

    /*筛选重置*/
    advanceReset() {
        let self = this;
        this.setState({
            key: 0,
            searchObj: {
                ...this.state.searchObj,
                code: '',
                productCode: '',
                erpStatus: '',
                orderType: '',
                gatherRealityAddress: '',
                channelCode: '',
                getProCode: '',
                customerOrderCode: '',
                startCreatedDate: '',
                endCreatedDate: '',
                buyCompanyId: '',
                specialOfferCode: '',
                completeFactory: ''
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.state.searchObj.p = 1;
        this.setState({
            key: this.state.searchObj.orderStatus,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from,
                    endCreatedDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*翻页*/
    pageChange(page, s) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = this.state.searchObj;
        self.setState({
            loading: true
        })
        searchObj.orderStatus = searchObj.orderStatus == 0 ? '' : searchObj.orderStatus;
        getOrderList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'salesAmount': result.dataMap ? result.dataMap.salesAmount : 0,
                    'loading': false
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'order' || path[0] === 'order') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...data.storeData,
                    code: this.props.location.query.code || '',
                    //...data.params
                },
                key:
                data.params.orderStatus
            });
        }
    }

    componentDidMount() {
        let self = this;
        this.initData();
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                // let arr = [
                //     {
                //         text: '全部',
                //         value: ''
                //     }
                // ];
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //渠道
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                });
                self.setState({channel_GouHuo: arr},
                )
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /*返回*/
    backTo() {
        window.history.go(-1);
    }

    downloadChange() {
        downLoadTemplate(11);
    }

    render() {
        const {
            opts, key, rows, total, searchObj,
            channel_type, loading, channel_GouHuo, editVisible, salesAmount
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'code',
                    label: '订单编码',
                    text: '输入订单编码',
                    type: 'default',
                    defaultValue: searchObj.code
                },
                {
                    name: 'productCode',
                    label: '物料编码/描述',
                    text: '输入物料编码/描述',
                    type: 'default',
                    defaultValue: searchObj.productCode
                },
                {
                    // name: 'orderStatus',
                    name: 'erpStatus',
                    label: '订单状态',
                    text: '选择订单状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: 'ERPBOOKED', text: '已登记'},
                        {value: 'CONFIRMED', text: '已确认'},
                        {value: 'SAVE', text: '暂存'},
                        {value: 'COMMIT', text: '已提交'},
                        {value: 'INAPPR', text: '评审中'},
                        {value: 'DTAPPR', text: '交期评审中'},
                        {value: 'PSAPPR', text: '评审中'},
                        {value: 'PSREBUT', text: '评审驳回'},
                        {value: 'DTREBUT', text: '交期驳回'},
                        {value: 'ERROR', text: '异常'},
                        {value: 'TREBUT', text: '终端驳回'},
                        {value: 'THRE', text: '天e驳回'},
                        {value: 'LARCH', text: '终端部已审核'},
                        {value: 'LARRE', text: '终端部驳回'},
                        {value: 'THCK', text: '天e审核'},
                        {value: 'TADUIT', text: '终端审核'},
                        {value: 'CLOSED', text: '已关闭'},
                        {value: 'ERPENABLE', text: '未登记'},
                        {value: 'CANCEL', text: '已取消'},
                        // { value: '', text: '全部' },
                        // { value: '1', text: '暂存' },
                        // { value: '2', text: '待客户确认' },
                        // { value: '3', text: '已提交' },
                        // { value: '4', text: '已驳回' },
                        // { value: '5', text: '驳回后提交' },
                        // { value: '6', text: '待收货' },
                        // { value: '7', text: '已完成' },
                        // { value: '8', text: '客户已驳回' },
                        // { value: '9', text: '已确认' },
                        // { value: '10', text: '大客户已确认' },
                        // { value: '11', text: '已登记' },
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.erpStatus || ''
                },
                {
                    name: 'orderType',
                    label: '订单类型',
                    text: '选择订单类型',
                    options: [
                        {value: '', text: '全部'},
                        {value: '1', text: '常规订单'},
                        {value: '2', text: '项目订单'},
                        {value: '3', text: '合作伙伴订单'},
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.orderType
                },
                {
                    name: 'gatherRealityAddress',
                    label: '实际收货地址',
                    text: '输入实际收货地址',
                    type: 'default',
                    defaultValue: searchObj.gatherRealityAddress
                },
                /*           {
                               name: 'channelCode',
                               label: '渠道类型',
                               text: '选择渠道类型',
                               options: channel_type,
                               multiple: false,//支持多选
                               type: 'select',
                               defaultValue: searchObj.channel
                           },*/
                {
                    name: 'orderTime',//startCreatedDate, endCreatedDate
                    label: '登记日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startCreatedDate || '',
                        end: searchObj.endCreatedDate || ''
                    },
                },
                {
                    name: 'getProCode',
                    label: '要货单号',
                    text: '输入要货单号',
                    type: 'default',
                    defaultValue: searchObj.getProCode
                },
                {
                    name: 'customerOrderCode',
                    label: '客户订单号',
                    text: '输入客户订单号',
                    type: 'default',
                    defaultValue: searchObj.customerOrderCode
                },
                {
                    name: 'buyCompanyId',
                    label: '购货单位',
                    text: '选择购货单位',
                    options: channel_GouHuo,
                    multiple: false,//支持多选
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.buyCompanyId
                },
                {
                    name: 'remark',
                    label: '备注',
                    text: '输入备注',
                    type: 'default',
                    defaultValue: searchObj.remark
                },
                {
                    name: 'specialOfferCode',
                    label: '价格单号',
                    text: '输入价格单号',
                    type: 'default',
                    defaultValue: searchObj.specialOfferCode
                },
                {
                    name: 'completeFactory',
                    label: '终端单位',
                    text: '输入终端单位',
                    type: 'default',
                    defaultValue: searchObj.completeFactory
                },
                {
                    name: 'contractOrderName',
                    label: '合同/订单',
                    text: '输入合同/订单',
                    type: 'default',
                    defaultValue: searchObj.contractOrderName
                },
                {
                    name: 'closeHomologous',
                    label: '结算对应号',
                    text: '输入结算对应号',
                    type: 'default',
                    defaultValue: searchObj.closeHomologous
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '要货单号',
                    dataIndex: 'getProCode',
                    render: (text, record, index) => {
                        if (record.orderType == "1") {
                            if (record.orderStatus == '1' || record.orderStatus == '4') {
                                return <a
                                    href={`#/order/${record.id}/conventionalDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                            } else {
                                return <a href={`#/order/${record.id}/conventionalDetail/${record.code}`}>{text}</a>;
                            }
                        }
                        if (record.orderType == "2") {
                            if (record.orderStatus == '1' || record.orderStatus == '4') {
                                return <a
                                    href={`#/order/${record.id}/projectDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                            } else {
                                return <a href={`#/order/${record.id}/projectDetail/${record.code}`}>{text}</a>;
                            }
                        }
                        if (record.orderType == "3") {
                            if (record.orderStatus == '1' || record.orderStatus == '4') {
                                return <a
                                    href={`#/order/${record.id}/partnersDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                            } else {
                                return <a href={`#/order/${record.id}/partnersDetail/${record.code}`}>{text}</a>;
                            }
                        }
                    }
                },
                {
                    title: '购货单位',
                    dataIndex: 'buyCompany'
                },
                {
                    title: '渠道',
                    dataIndex: 'channel'
                },
                {
                    title: '订单类型',
                    dataIndex: 'orderType',
                    render: (text, record, index) => {
                        if (text === "1") return '常规订单';
                        if (text === "2") return '项目订单';
                        if (text === "3") return '合作伙伴订单';
                        return '';
                    }
                },
                // {
                //     title: '产品线',
                //     dataIndex: 'proLine',
                //
                // },
                {
                    title: '登记日期',
                    dataIndex: 'createdDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                },
                {
                    title: '销售金额(元)',
                    dataIndex: 'realityAmount',
                    render: (text, record, index) => {
                        // console.log(record.productList[0].terminalUnitPrice)
                        // // debugger
                        //      let x = record.productList[0].terminalUnitPrice;
                        return <Tooltip title="存在产品取消的情况，实际销售金额以‘报表→开单含折让报表’为准"><span
                            style={{color: '#d61518'}}>{record.listAmount ? '¥' + formatMoney(record.sellinAmount || 0) : '¥' + formatMoney(text)}</span></Tooltip>
                    }
                },
                {
                    title: '订单状态',
                    dataIndex: 'erpStatus',
                    /*render: (text, record, index) => {
                        if (text === 1) return '暂存';
                        if (text === 2) return '待客户确认';
                        if (text === 3) return '已提交';
                        if (text === 4) return '已驳回';
                        if (text === 5) return '驳回后提交';
                        if (text === 6) return '待收货';
                        if (text === 7) return '已完成';
                        if (text === 8) return '客户已驳回';
                        if (text === 9) return '已确认';
                        if (text === 10) return '大客户已确认';
                        return '';
                    }*/
                },
                {
                    title: '订单编号',
                    dataIndex: 'code',
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text} &nbsp;
                                    {record.specialShipFlag ?
                                        <Tag color="green">直发订单</Tag> : null}
                                    </span>
                            </div>
                        )
                    }
                },
                {
                    title: '合同/订单',
                    dataIndex: 'contractOrderName'
                },
                {
                    title: '结算对应号',
                    dataIndex: 'closeHomologous'
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    render: (text, record, index) => {
                        if (record.orderType === "3") {
                            return <div>{'客户订单号:' + record.customerOrderCode || ''}</div>
                        } else {
                            return <div>{text}</div>
                        }
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    width: '125',
                    render: (text, record, index) => {
                        // if (record.orderStatus == 1)
                        //     return <Button size={'small'} onClick={self.auditRecord.bind(self, index)}>审核</Button>;
                        // if (record.orderStatus == 3)
                        //     return <Button size={'small'} onClick={self.confirmRecord.bind(self, index)}>确认收货</Button>;

                        // if (record.orderStatus == 4)
                        //     return <Button size={'small'} onClick={self.evaluationRecord.bind(self, index)}>评价</Button>;
                        // if (this.state.userData.ownEmp == false)
                        if (record.orderStatus == 1 || record.orderStatus == 2 || record.orderStatus == 4) {
                            if (record.createdBy == this.state.userData.id || this.state.userData.ownEmp == false) {
                                if (record.orderSource == 'BPM') {
                                    return (<div>
                                        <Button size={'small'} style={{display: 'inline-block', marginRight: '10px'}}
                                                onClick={self.editRecord.bind(self, record, index)}>编辑</Button>
                                        <Popover placement="left"
                                                 content='该订单为特批订单，如果要删除，请联系天正销售人员。'
                                                 trigger="click">
                                            <Button size={'small'} type="danger">删除</Button>
                                        </Popover>
                                    </div>)
                                } else {
                                    return (<div>
                                        <Button size={'small'} style={{display: 'inline-block', marginRight: '10px'}}
                                                onClick={self.editRecord.bind(self, record, index)}>编辑</Button>
                                        <Popconfirm placement="left"
                                                    title='订单删除后，将无法恢复，请谨慎操作，以免误删影响交货及时。请您确定是否要删除该订单？'
                                                    onConfirm={() => {
                                                        this.deleteRecord(index)
                                                    }}>
                                            <Button size={'small'} type="danger">删除</Button>
                                        </Popconfirm>
                                    </div>)
                                }
                            }
                        } else {
                            if (record.orderStatus != 9) {
                                if (record.createdBy == this.state.userData.id || this.state.userData.ownEmp == false) {
                                    return (<div>
                                        <Tooltip title="刷新订单状态及反馈信息"><Button size={'small'} style={{
                                            display: 'inline-block',
                                            marginRight: '10px'
                                        }}
                                                                                        onClick={self.refreshRecord.bind(self, record, index)}>刷新</Button></Tooltip>
                                    </div>)
                                }
                            }
                        }
                    }
                }
            ],
            rows
        };
        let self = this;
        let backHide = (customerManagementId) => {
            if (customerManagementId) {
                return <Button onClick={self.backTo.bind(self)}>返回</Button>
            } else {
                return '';
            }
        }
        let uploadParam = toImportExcel(
            11,
            () => {
                self.initData();
            }
        );
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                {backHide(this.customerManagementId)}
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                    <span>{total}个订单，销售金额汇总：
                        <Tooltip title="存在产品取消的情况，实际销售金额以‘报表→开单含折让报表’为准">
                            <span>¥{formatMoney(salesAmount || 0)}</span>
                        </Tooltip>
                        <font size={1} style={{color: 'red'}}>（默认显示一年内订单)</font></span>
                    <Button onClick={this.downloadChange.bind(this)}
                            style={{position: 'absolute', bottom: 8, right: 574}}>下载模板</Button>
                    <Upload {...uploadParam}>
                        <Button style={{position: 'absolute', bottom: 8, right: 483}}>
                            <Icon type="upload"/>导入
                        </Button>
                    </Upload>
                    {this.orgId != '86' && <Button style={{position: 'absolute', bottom: 8, right: 360}}
                                                   onClick={this.goView.bind(this, '/shoppingCar/add/1')}>新增常规订单</Button>}
                    <Button style={{position: 'absolute', bottom: 8, right: 238}}
                            onClick={this.goView.bind(this, '/shoppingCar/add/2')}>新增项目订单</Button>
                    <Button style={{position: 'absolute', bottom: 8, right: 88}}
                            onClick={this.goView.bind(this, '/shoppingCar/add/3')}>新增合作伙伴订单</Button>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

//使用高阶组件withRouter来封装OrderList。目的是将router对象暴露出来
export default withRouter(OrderList);



// WEBPACK FOOTER //
// ./src/routes/order/list.js